export type GroupMonthlyMemo = Readonly<{
  nurse_id: string;
  name: string;
  monthly_memo: string;
  updated_at: string | null;
}>;

export function buildGroupMonthlyMemoByNurse(
  memos: readonly GroupMonthlyMemo[]
): ReadonlyMap<string, GroupMonthlyMemo> {
  const memoByNurse = new Map<string, GroupMonthlyMemo>();

  for (const memo of memos) {
    const nurseId = memo.nurse_id.trim();
    const monthlyMemo = memo.monthly_memo.trim();
    if (!nurseId || !monthlyMemo) continue;

    memoByNurse.set(nurseId, {
      ...memo,
      nurse_id: nurseId,
      monthly_memo: monthlyMemo,
    });
  }

  return memoByNurse;
}
